import React from "react";
import { CodeView } from "components/CodeView";
import { EditorView } from "@codemirror/view";
import { analyticsCodeViewTheme } from "utils/analytics/themes";

interface RequestCodeViewProps {
  requestText: string;
  onClick: (e: React.MouseEvent) => void;
}

const RequestCodeView: React.FC<RequestCodeViewProps> = ({
  requestText,
  onClick,
}) => {
  return (
    <div className="cursor-pointer" onClick={onClick}>
      <div className="rounded overflow-hidden">
        <div className="w-full dark:border dark:border-gray-200">
          <CodeView
            language="text"
            content={requestText}
            minHeight="5rem"
            maxHeight="10rem"
            theme={analyticsCodeViewTheme}
            basicSetup={{
              lineNumbers: true,
              foldGutter: false,
              dropCursor: false,
              allowMultipleSelections: false,
              indentOnInput: false,
              bracketMatching: true,
              closeBrackets: false,
              autocompletion: false,
              rectangularSelection: false,
              highlightSelectionMatches: false,
              searchKeymap: false,
            }}
            editable={false}
            extensions={[EditorView.lineWrapping]}
          />
        </div>
      </div>
    </div>
  );
};

export default RequestCodeView;
